module.exports = __webpack_public_path__ + "static/media/1.ca4cb3a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80264/1.jpg
// module id = 771
// module chunks = 0